import clsx from 'clsx';
import { Progress } from './Progress';

export interface ProgressBarProps {
  className?: string;
  indeterminate?: boolean;
  showPercentage?: boolean;
  value?: number;
}

export const ProgressBar = (props: ProgressBarProps) => {
  const value = parseInt((((props.value ?? 0) / 100) * 100).toFixed(0));
  if (props.showPercentage && props.indeterminate === undefined)
    return (
      <div className="inline-flex gap-2 items-center w-full">
        <Progress {...props} />
        <p
          className={clsx('w-9', {
            ['transition-all text-primary duration-500 text-lg w-fit']:
              value >= 100,
          })}
        >{`${value}%`}</p>
      </div>
    );
  return <Progress {...props} />;
};
